import styled from 'styled-components';

export const QRCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px;
`;
